import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { reset } from 'redux-form';
import List from './List';
import Filter from './Filter';
import { loadPrepaidTermsReport, exportPrepaidTerms } from './actions';
import { initialize } from 'redux-form';

class PrepaidTermsReport extends Component {

	constructor(props) {
		super(props);
		this.handleFilterSubmit = this.handleFilterSubmit.bind(this);
		this.handleListEvent = this.handleListEvent.bind(this);
		this.handleTermSelected = this.handleTermSelected.bind(this);
		this.state = {
			termId: null
		};
	}

	componentDidMount() {
		const { filter, sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;

		if (filter && filter.termId) {
			this.loadData({ filter, sortKey, sortDirection, pageNumber, pageSize });
			this.props.initializeFilter(filter);
			this.setState({ termId: filter.termId });
		}
	}

	handleTermSelected(termId) {
		// trigger filter on initial load when Active Term is selected by default in the dropdown
		if (this.state.termId === null) {
			const { filter = {} } = this.props.pagination;
			if (!filter.termId) {
				filter.termId = termId;
				this.props.initializeFilter(filter);
			}

			this.loadData({ ...this.props.pagination, filter: { ...filter } });
		}
		this.setState({ termId });
	}

	handleFilterSubmit(options) {
		const { isExport, ...filter } = options;
		const { sortKey, sortDirection, pageSize } = this.props.pagination;
		this.loadData({ filter, sortKey, sortDirection, pageNumber: 1, pageSize });
		if (isExport)
			this.exportData(filter);
	}

	handleListEvent(listPagination) {
		const { filter } = this.props.pagination;
		this.loadData({ filter, ...listPagination });
	}

	loadData({ filter, sortKey, sortDirection, pageNumber, pageSize }) {
		const { loadReport } = this.props;
		loadReport({ ...filter, sortKey, sortDirection, pageSize, pageNumber });
	}

	exportData(filter) {
		this.props.exportPrepaidTerms(filter);
	}

	render() {
		const { data, requireChildSchool } = this.props;

		return (
			<div>
				<Filter
					onSubmit={this.handleFilterSubmit}
					onTermSelected={this.handleTermSelected}
					loading={this.props.pagination.loading || this.props.export.loading}
				/>
				<List
					data={data}
					onFetchData={this.handleListEvent}
					requireChildSchool={requireChildSchool}
					{...this.props.pagination}
				/>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	
	const {
		pagination,
		exports,
		entities: { prepaidTermsReport },
		configuration: { franchisor }
	} = state;

	const prepaidTermsReportPagination = pagination.prepaidTermsReport.all || { ids: [], pageNumber: 1, pageSize: 10 };
	const prepaidTermsExport = exports.prepaidTerms.all || {};

	return {
		data: prepaidTermsReportPagination.ids.map(id => prepaidTermsReport[id]),
		pagination: prepaidTermsReportPagination,
		export: prepaidTermsExport,
		requireChildSchool: franchisor.requireChildSchool
	};
};

const mapDispatchToProps = {
	loadReport: loadPrepaidTermsReport,
	exportPrepaidTerms,
	resetFilter: () => reset('prepaidTermsReportFilter'),
	initializeFilter: (data, fields) => initialize('prepaidTermsReportFilter', data, fields)
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(PrepaidTermsReport));